import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import PopularSection from './components/PopularSection';
import BenefitsSection from './components/BenefitsSection';
import CTASection from './components/CTASection';
import SeoJsonLd from '../../components/feature/SeoJsonLd';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Localygo',
  url: SITE_URL,
  description: 'Plateforme de livraison de repas locale. Commandez auprès de vos restaurants préférés, livré par des habitants indépendants.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_URL}/restaurants?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Localygo',
  url: SITE_URL,
  logo: `${SITE_URL}/vite.svg`,
  description: 'Localygo est une plateforme de livraison de repas locale connectant restaurants, livreurs et clients.',
  sameAs: [],
};

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Livraison de repas Localygo',
  provider: {
    '@type': 'Organization',
    name: 'Localygo',
  },
  serviceType: 'Livraison de repas à domicile',
  description: 'Service de livraison de repas locale rapide. Plus de 50 restaurants partenaires, livraison en 30 minutes en moyenne.',
  areaServed: {
    '@type': 'Country',
    name: 'France',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <SeoJsonLd data={websiteSchema} id="schema-website" />
      <SeoJsonLd data={organizationSchema} id="schema-organization" />
      <SeoJsonLd data={serviceSchema} id="schema-service" />
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <HowItWorksSection />
      <PopularSection />
      <BenefitsSection />
      <CTASection />
      <Footer />
    </div>
  );
}
